<template>
      <div class="schedule-list-container">
      <v-data-table
          :headers="headers"
          :items="items"
          dense
          :hide-default-footer="true"
          :disable-pagination="true"
          no-data-text="No Filters"
          :show-expand="true"
          :item-class="row_classes"
          :fixed-header="true"
          class="filter-table"
          width="100%"
          height="500"
          :key="`filter_list_${refresh}`"
          :search="filterSearch"
      >

            <template v-slot:top>
              <v-text-field
                class="pa-0 ma-0 ml-n2 "
                flat
                dense
                solo
                hide-details
                v-model="filterSearch"
                label="Filter"
                background-color="ycmd-very-lightest-gray"
              ></v-text-field>
            </template>

            <template v-slot:item.name="{item, value}">
                <div
                    @click="rowClick(item)"
                    style="width: 100%;height: 100%;"    
                >{{ value }}</div>
            </template>
            <template v-slot:item.type="{item, value}">
                <div
                    @click="rowClick(item)"
                    style="width: 100%;height: 100%;"    
                >{{ value }}</div>
            </template>
            <template v-slot:item.user_name="{item, value}">
                <div
                    @click="rowClick(item)"
                    style="width: 100%;height: 100%;"    
                >{{ value }}</div>
            </template>
            <template v-slot:item.createdBy="{item, value}">
                <div
                    @click="rowClick(item)"
                    style="width: 100%;height: 100%;"
                >{{ value }}</div>
            </template>
            <template v-slot:item.createdOn="{item, value}">
                <div
                    @click="rowClick(item)"
                    style="width: 100%;height: 100%;"
                >{{ value }}</div>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td
                  :colspan="headers.length"
                  classxxx="pa-0 ma-0 fs-10 pl-5 font-weight-light "    
              >
                  <div v-if="item.rules && item.rules.length"
                      v-html="rulesHtml(item.rules)"
                  />
                  <div
                    v-else
                  >No rules
                  </div>
              </td>
            
            </template>          

          
          <template v-slot:item.actionsxxx="{item}">

            <v-tooltip 
                        bottom
                        nudge-bottom="5"
                        color="ycmd-black"
                        content-class="fade-0">
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="ycmd-blue"
                  class="pointer"
                  :size="22"

                >
                  edit
                </v-icon>
              </template>
              <span>Edit</span>
            </v-tooltip>

          </template>                       

      </v-data-table>
      </div>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {formatSimple} from '@/methods/formatters';

import { parseJSON } from 'date-fns';
  export default {
    props: {
      shifts: {
          type: Array,
          default: () => []
      },
      filters: {
          type: Array,
          default: () => []
      },   
      refresh: {
        default: '',
        type: String
      },                     
              
    },
    components: {

    },    
    data: () => ({
      filterSearch: null
    }),
    mounted() {
    },
    methods: {
      ...mapGetters('schedule',['getFacilityById']),
      twoDigit (num) {
        let str = num + ''
        if (str.length === 1) {
            str = '0' + str
        }
        return str
      },
      formatTime(time) {
        let pieces = time.split(':')
        let pm = false

        if (pieces[0] >= 12) {
          pieces[0] -= 12
          pm = true
        }
        return `${this.twoDigit(pieces[0])}:${this.twoDigit(pieces[1])}:${this.twoDigit(pieces[2])} ${pm ? 'PM': 'AM'}`
      },

      rulesHtml (rules) {

          if (rules && rules.length) {
              let options = ''
              rules.map(r => {
                  options += `<li>${r}</li>`
              })
              let html = `<h5>Rules</h5><ul>${options}</ul>`
              return html
          }

          return null
      },   
      
      formatDate(dt) {

          let formatted = formatSimple(dt,'MM/dd/yyyy hh:mm a')
          
          return formatted
      },
      
      rowClick(item) {

        this.$emit('select', item)
      },
      translateFilter(filter) {

        let f = JSON.parse(JSON.stringify(filter))
        switch (f.user_type) {
          case 'provider':
            f.type = 'Provider'
            break
          case 'group':
            f.type = 'Group'
            break
          case 'pod':
            f.type = 'Pod'
            break
        }

        f.createdBy = `${f.created_by_first_name} ${f.created_by_last_name}`

        f.createdOn = this.formatDate(new Date(f.date_created))

        return f

      },
      row_classes(item) {
        let classes = ['pa-0', 'ma-0', 'pointer']

        if (item.odd) {
          classes.push('odd')
        }

        return classes
      },      
    },
    computed: {
      items () {
        let arr = []
        let i=0
        this.filters.map(s => {
          let translated = this.translateFilter(s)
          translated.odd = i++ % 2
            
          arr.push(translated)
        })

        let sorted = arr.sort( (a,b) => {
            return a.name.localeCompare(b.name)
        })

        return sorted
      },
      headers () {
        let headers = [    
            {
                text: 'Name',
                value: 'name',
                width: '30%',
                sortable: true,
                cellClass:"pa-0 ma-0 pt-1",
                
            },
            {
                text: 'Type',
                value: 'type',
                width: '10%',
                sortable: true,
                cellClass:"pa-0 ma-0 pt-1",
            },            
            {
                text: 'Owner',
                value: 'user_name',
                width: '20%',
                sortable: true,
                cellClass:"pa-0 ma-0 pt-1",
            },
            {
                text: 'Created By',
                value: 'createdBy',
                width: '20%',
                sortable: true,
                cellClass:"pa-0 ma-0 pt-1",
            },  
            {
                text: 'Created On',
                value: 'createdOn',
                width: '20%',
                sortable: true,
                cellClass:"pa-0 ma-0 pt-1",
            },              
            { text: '', 
                value: 'data-table-expand',
                cellClassxxx:"fs-12 filterTableExpand"
            },                                                                                  
        ]

        return headers
      },  
      actionList () {
        return []
      },

    },
    watch: {

    }
  }
</script>

